var _rect, _ellipse, _ellipse2, _path, _path2, _circle, _path3, _path4, _circle2, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.227,
    cy: 46.8884,
    rx: 8.10556,
    ry: 4.39624,
    fill: "#B0D4FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.1128,
    cy: 74.7771,
    rx: 8.10556,
    ry: 4.39624,
    fill: "#B0D4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9621 38.7137L19.5644 43.316L21.6168 45.24C23.1005 46.504 23.4111 46.7506 23.4798 46.6819C25.0513 47.5069 26.1587 45.8347 26.6396 45.3081L31.9288 39.8815C36.2151 35.8699 36.0862 31.8453 35.9129 29.4404C35.4733 23.3406 30.326 20.2129 27.8073 19.4115C18.5203 17.3782 13.9088 23.3727 12.764 26.6241C10.6757 32.559 13.3593 37.1567 14.9621 38.7137Z",
    fill: "#FE646F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.005 33.8423C15.0267 24.4453 22.4087 20.1727 26.347 19.211C19.5328 17.9471 14.9443 22.6685 13.5018 25.1872C10.0947 31.7266 13.2728 37.3455 15.2877 39.3376L19.2718 43.253L22.7064 46.4814C24.1583 47.7129 24.786 47.7766 26.2878 45.7209C20.133 40.7751 17.5545 35.6969 17.005 33.8423Z",
    fill: "#FD4755"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.021,
    cy: 30.334,
    r: 5.15184,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9853 66.6024L65.5876 71.2047L67.64 73.1287C69.1237 74.3926 69.4343 74.6393 69.503 74.5706C71.0745 75.3955 72.1819 73.7234 72.6628 73.1968L77.952 67.7701C82.2383 63.7586 82.1094 59.7339 81.9361 57.3291C81.4965 51.2293 76.3492 48.1016 73.8305 47.3002C64.5435 45.2669 59.932 51.2614 58.7872 54.5127C56.6989 60.4477 59.3825 65.0454 60.9853 66.6024Z",
    fill: "#2ED1E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0282 61.7309C61.0499 52.334 68.4319 48.0614 72.3702 47.0997C65.556 45.8358 60.9675 50.5572 59.525 53.0758C56.1179 59.6152 59.296 65.2342 61.3109 67.2262L65.295 71.1416L68.7296 74.3701C70.1815 75.6016 70.8092 75.6653 72.311 73.6095C66.1562 68.6638 63.5777 63.5856 63.0282 61.7309Z",
    fill: "#02C7DD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.0441,
    cy: 58.2226,
    r: 5.15184,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9523 53.6203V73.5407C24.4102 77.2043 27.4693 84.4489 36.0419 84.1192C38.7896 84.0734 44.6695 82.3332 46.2082 75.7388V34.9363C46.2998 30.4942 48.8734 21.7476 58.4353 22.2971C61.8698 21.7018 68.9862 23.6434 69.9754 36.1727",
    stroke: "#FFE177",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3044 35.2109H67.2277H73.2038C74.5227 35.4307 74.6693 36.6763 74.5777 37.2717L70.5249 44.1408C69.3159 45.2948 68.3726 44.4385 68.052 43.866L64.274 37.2717C63.6695 35.678 64.709 35.2338 65.3044 35.2109Z",
    fill: "#FFE177"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.94b50f8f13010fc09511ddafb2c0d856.svg";
export { ForwardRef as ReactComponent };